<template>
    <div class="container q-my-xl comments">
        <div v-if="loading" class="row justify-center">
            <q-spinner-hourglass color="primary" size="50px"></q-spinner-hourglass>
        </div>
        <template v-else>
            <div class="row q-mb-xl gutter-sm" v-if="user">
                <div class="col-md-6 offset-md-3 col-sm-10 offset-sm-1 col-xs-12"> 
                    <q-input v-model="newComment"
                             :placeholder="$T('write your comment here (optional)')"
                             type="textarea"
                             :dir="textDirection"
                             :max-height="10"
                             hide-underline
                             rows="7"
                    />
                </div>
                <div class="col-md-3 offset-md-3 col-sm-5 offset-sm-1 col-xs-6">
                    <q-btn no-caps color="primary" class="super-hover full-width"
                           :label="$T('cancel')" @click.prevent="cancel"></q-btn>
                </div>
                <div class="col-md-3 col-sm-5 col-xs-6">
                    <q-btn no-caps color="primary" class="super-hover full-width"
                           :label="$T('send')" @click.prevent="submit"></q-btn>
                </div>
            </div>
            <div class="row gutter-md q-mb-lg items-start" v-for="comment in comments" :key="comment.created_at">
                <div class="col-auto">
                    <div class="image avatar row justify-center items-center">
                        <img class="responsive" v-lazy="(comment.avatar ? comment.avatar.icon :comment.avatar)" :key="comment.avatar">
                    </div>
                </div>
                <div class="col row">
                    <div class="col-md-4 col-xs-12 col-sm-12 q-mb-md">
                        <h5 v-html="comment.name" class="q-mt-lg q-mb-none text-white"></h5>
                        <small>{{ comment.created_at }}</small>
                    </div>
                    <div class="col-md-8 col-xs-12 col-sm-12">
                        <div class="comment-body" :class="{ 'ellipsis-3-lines': !isVisible(comment.id) }"
                             v-html="comment.body"></div>
                        <div class="text-right q-mt-md">
                            <q-btn no-caps dense flat rounded color="light" v-ripple class="readmore"
                                   :icon="isVisible(comment.id) ? 'arrow drop up' : 'arrow drop down'"
                                   @click.prevent="toggleVisibility(comment.id)"
                                   :label="$T(isVisible(comment.id) ? 'read less' : 'read more')"></q-btn>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row gutter-sm justify-center q-mt-md">
                <div class="col-auto">
                    <q-btn :disable="page <= 1" no-caps color="primary" class="super-hover"
                           :label="$T('previous page')" @click.prevent="prevPage"></q-btn>
                </div>
                <div class="col-auto">
                    <q-btn :disable="page >= total" no-caps color="primary" class="super-hover"
                           :label="$T('next page')" @click.prevent="nextPage"></q-btn>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import {
        QSpinnerHourglass,
        QInput,
        QBtn,
        Cookies
    } from 'quasar-framework'
    import {mapGetters} from 'vuex'
    import axios from 'axios'

    export default {
        name: 'VComments',

        props: {
            contentType: {
                type: String,
                requered: true
            },
            contentId: {
                type: Number,
                requered: true
            },

        },
        computed:{
            ...mapGetters({
                user: 'auth/user',
            }),
        },
        data: () => ({
            newComment: '',
            visibles: [],
            comments: [],
            loading: false,
            page: 1,
            total: 1,
            textDirection: 'rtl',
            lang: window.config.locale.toUpperCase(),
            portal_base: null
        }),

        components: {
            QSpinnerHourglass,
            QInput,
            QBtn
        },

        methods: {
            toggleVisibility(id) {
                this.$set(this.visibles, id, typeof this.visibles[id] !== 'undefined' ? !this.visibles[id] : true)
            },

            isVisible(id) {
                return typeof this.visibles[id] !== 'undefined' && this.visibles[id]
            },

            nextPage() {
                this.loadPage(++this.page)
            },

            prevPage() {
                this.loadPage(--this.page)
            },

            loadPage(page) {
                this.loading = true
                this.visibles = []
                axios.get(`${config.appUrl}/${this.portal_base}/${this.user.id}/comments/${this.contentType}/${this.contentId}?page=` + page)
                    .then(({data}) => {
                        this.comments = data.comments;
                        this.total = data.total;
                        this.loading = false

                    })
                    .catch(error => {
                        this.loading = false
                    })
            },

            cancel() {
                this.newComment ="";
            },

            submit() {
                this.loading = true
                axios.post(`${config.appUrl}/${this.portal_base}/${this.user.id}/comment/${this.contentType}/${this.contentId}/save`, {body: this.newComment, user: this.user})
                    .then(({data}) => {
                        this.loading = false
                        if(data.hasOwnProperty("error"))
                            this.$q.notify({
                                color: 'red',
                                icon: 'warning',
                                message: this.$T(data.error),
                                detail: this.$T(""),
                                position: 'bottom'
                            })
                        else
                            this.newComment = "";
                        this.loadPage(1);
                    })
                    .catch(error => {
                        this.loading = false
                    })
            },
            getLang(){
                if (this.lang === 'AR'){
                    this.textDirection = 'rtl'
                }else{
                    this.textDirection = 'ltr'
                }
            }
        },

        mounted() {
            this.portal_base = Cookies.get('portal')
            this.loadPage(1)
            this.getLang()
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Comments.vue